import { z } from 'zod'
import {
  dateSchema,
  priceRequiredScheme,
  stringRequiredScheme,
} from '~/shared/lib/schemas'
import { Car } from './car'
import { ApiModel } from './core'

const attributeSchema = z.object({
  number: stringRequiredScheme,
  issuedDate: dateSchema,
  expirationDate: z
    .string()
    .max(0)
    .or(dateSchema)
    .optional()
    .nullable()
    .transform((arg) => arg || null),
  issuedBy: z.string().optional(),
  paidAmount: priceRequiredScheme.optional().nullable(),

  files: z
    .object({
      id: z.string(),
      name: z.string(),
      filepath: z.string().url(),
      preview: z.string().url(),
    })
    .array()
    .optional(),
})

const schema = z
  .object({
    createdAt: dateSchema,
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)

export type PatentAttributes = z.infer<typeof attributeSchema>

export class Patent extends ApiModel<typeof schema> {
  static jsonApiType = 'patents'

  static schema = schema

  setCar(id: UniqueId) {
    const car = new Car()
    car.setApiId(id)
    this.setRelation('car', car)
  }

  getCreatedAt(): string {
    return this.getAttribute('createdAt')
  }

  getFiles(): PatentAttributes['files'] {
    return this.getAttribute('files')
  }
}
